// extracted by mini-css-extract-plugin
export var wrapper = "blogs-module--wrapper--1pDPK";
export var title = "blogs-module--title--wwY9K";
export var highlighted = "blogs-module--highlighted--RCGth";